import './vision.css';
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';
import { images } from '../config/imagePaths';

function OurVision() {
  return (
    <div className="page-wrapper vision-page">
      <Seo
        title="Our Vision"
        description="The vision, impact, and future goals of AOK Communications."
      />
      <Header />

      <section className="vision-hero reveal page-content">
        <div className="vision-hero-text">
          <span className="vision-eyebrow">Our Vision</span>
          <h1>Helping people communicate with courage and clarity</h1>
          <p>
            Our vision is to create classrooms, workplaces, and communities where people can
            express ideas clearly, lead with confidence, and be heard for who they are.
          </p>
        </div>
        <div className="vision-hero-image hover-lift">
          <img
            src={images.services.vision}
            alt="AOK Communications team standing in front of the AOK logo"
          />
        </div>
      </section>

      <section className="vision-impact reveal-left page-content">
        <div className="impact-inner">
          <div className="impact-text">
            <h2>Empowering Growth Through Clarity</h2>
            <p>
              AOK Communications exists to bridge the gap between potential and expression. Our vision is to empower individuals and organizations
              to communicate clearly, confidently, and courageously — no matter their background, age, or experience.
            </p>
            <p>
              We envision classrooms where students speak with conviction. Boardrooms where professionals lead with empathy.
              Communities where ideas are heard, respected, and amplified.
            </p>
          </div>
        </div>
      </section>

      <section className="vision-awards reveal">
        <h2>Recognized for Impact</h2>
        <p className="subtitle">We’re proud to be an award-winning organization making real change in how people speak and lead.</p>
        <div className="award-grid stagger-children">
          <div className="award-card hover-lift">
            <h4>2025 Laois Rising Star Award</h4>
            <p>Recognized as an emerging entrepreneur making a significant impact in the county</p>
          </div>
          <div className="award-card hover-lift">
            <h4>Digital Learning Innovation</h4>
            <p>Honoured for modernizing public speaking education with real-world storytelling and skill-based coaching.</p>
          </div>
        </div>
      </section>

      <section className="vision-future reveal-scale">
        <h2>Where We're Headed</h2>
        <p>
          In the next five years, we aim to expand our reach through digital courses, school partnerships, and industry collaborations —
          shaping confident communicators at every level. The tools may evolve. Our purpose will not.
        </p>
      </section>

      <Footer />
    </div>
  );
}

export default OurVision;
